'use client';

import React, { useEffect, useMemo, useState } from 'react';

import { TasticProps } from '../types';
import {
  AlgoliaRecommendationProvider,
  LookingSimilarItems,
} from 'components/commercetools-ui/organisms/product/product-recommendations';
import { useCart } from 'frontastic/hooks';
import { LineItem } from 'shared/types/cart';
import { useBadgeLoader } from 'helpers/utils/badgeLoader';
import { P2Badge } from 'components/commercetools-ui/organisms/product/product-list-algolia/types';
import useLocale from 'helpers/hooks/useLocale';

const AlgoliaLookingSimilarProductTastic = ({ data }: TasticProps<any>) => {
  const { locale } = useLocale();
  const [variantCode, setVariantCode] = useState<string | null>(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      setVariantCode(params.get('variantCode'));
    }
  }, []);
  const { data: cart } = useCart();
  const variantCodes = useMemo(() => {
    if (variantCode) return [variantCode];

    const codes = cart?.lineItems?.map((lineItem: LineItem) => lineItem?.variant?.attributes?.variantCode);
    return codes?.filter(Boolean) || [];
  }, [variantCode, cart?.lineItems?.length]);
  const p1BadgeData = data?.data?.dataSource?.p1BadgeData;
  const p2BadgeData = data?.data?.dataSource?.p2BadgeData;
  const p1Badges = useBadgeLoader(p1BadgeData?.productListingContent);
  const p2Badges = p2BadgeData?.productListingContent as P2Badge[];
  const queryParameters = data?.data?.dataSource?.searchQuery?.[locale?.replace('-', '_')];
  if (!data?.isEnableLookingSimilar || variantCodes?.length === 0) return <></>;
  return (
    <AlgoliaRecommendationProvider>
      <div>
        <LookingSimilarItems
          objectIDs={variantCodes}
          title={data?.lookingSimilarTitle}
          p1BadgeData={p1Badges}
          p2BadgeData={p2Badges}
          queryParameters={queryParameters}
        />
      </div>
    </AlgoliaRecommendationProvider>
  );
};

export default AlgoliaLookingSimilarProductTastic;
